import saveAs from '../../../vendor/save-as';
import 'canvas-toBlob';

export default angular
  .module('doxy.realtime.common.directives.saveAs', [])
  .directive('dSaveAs', function ($window) {
    function base64toBlob(base64, onsuccess, onerror) {
      const img = new $window.Image();

      img.onerror = onerror;

      img.onload = function onload() {
        const canvas = $window.document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(onsuccess);
      };

      img.src = base64;
    }

    return {
      restrict: 'A',
      scope: {
        file: '=dSaveAs',
      },
      link: function (scope, element, attrs) {
        element.on('click', function () {
          base64toBlob(scope.file, function (blob) {
            saveAs(blob, attrs.dFileName);
          });
        });
      },
    };
  }).name;
